import { type JSX } from 'react/jsx-runtime';

export const SlackDarkIcon = (): JSX.Element => (
	<svg height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<rect width="24" height="24" rx="5" ry="5" fill="#1F1F21" />
		<g fill="none" fillRule="evenodd">
			<path
				d="M6.84 14.34a1.88 1.88 0 0 1-1.876 1.877 1.88 1.88 0 0 1-1.877-1.877 1.88 1.88 0 0 1 1.877-1.876H6.84zm.946 0c0-1.033.844-1.876 1.877-1.876s1.876.843 1.876 1.876v4.7a1.88 1.88 0 0 1-1.876 1.876 1.88 1.88 0 0 1-1.877-1.876z"
				fill="#e01e5a"
			/>
			<path
				d="M9.663 6.84a1.88 1.88 0 0 1-1.877-1.876c0-1.034.844-1.877 1.877-1.877s1.876.844 1.876 1.877V6.84zm0 .946c1.032 0 1.876.844 1.876 1.877a1.88 1.88 0 0 1-1.876 1.876h-4.7a1.88 1.88 0 0 1-1.875-1.876c0-1.033.844-1.877 1.877-1.877z"
				fill="#36c5f0"
			/>
			<path
				d="M17.162 9.663c0-1.033.844-1.877 1.877-1.877s1.876.844 1.876 1.877a1.88 1.88 0 0 1-1.875 1.876h-1.878zm-.945 0a1.88 1.88 0 0 1-1.877 1.876 1.88 1.88 0 0 1-1.876-1.876v-4.7c0-1.031.843-1.875 1.876-1.875s1.877.844 1.877 1.877z"
				fill="#2eb67d"
			/>
			<path
				d="M14.34 17.162c1.033 0 1.877.844 1.877 1.877a1.88 1.88 0 0 1-1.877 1.876 1.88 1.88 0 0 1-1.876-1.875v-1.878zm0-.945a1.88 1.88 0 0 1-1.876-1.877 1.88 1.88 0 0 1 1.876-1.876h4.7a1.88 1.88 0 0 1 1.876 1.876 1.88 1.88 0 0 1-1.876 1.877z"
				fill="#ecb22e"
			/>
		</g>
	</svg>
);
